import * as Action from "../redux/initialization_reducer"

export const initializeExam = (examDetails) => async (dispatch) => {
    try {
        await dispatch(Action.initExam(examDetails))
    } catch(error){
        console.log(error)
    }
}